import React, { memo } from 'react';
import { withTranslation } from 'react-i18next';
import { TextStyle } from '@ticketmaster/global-design-system';

import { T } from '@/v2/helpers/i18n';
import { resolveLabel } from '@/v2/helpers/labels/labelsHelper';

import styles from './item.module.scss';

type Props = {
  title: string;
  data: any;
  children?: any;
  titleOverride?: string;
} & T;

const InfoItem = ({ t, title = '', data = [], children, titleOverride }: Props) => {
  if (!Array.isArray(data)) {
    data = [data];
  }
  if (!data.length && !children) {
    return null;
  }
  data = data.filter((item: any) => !!item); // item exists

  return (
    <div className={styles.infoItem}>
      {(children || data.length) && title &&
          <div className={styles.infoItemTitle}>
              <TextStyle.Nevis>{resolveLabel(titleOverride, t(title))}</TextStyle.Nevis>
          </div>
      }
      <div>
        {data.map((text: string, key: number) => (
          <TextStyle.Etna key={key} style={{ wordBreak: 'break-word' }}>
            {text}
          </TextStyle.Etna>
        ))}
      </div>
      {!!children && children}

    </div>
  );
};

export default withTranslation('translation')(memo(InfoItem));
